type THeaderRendererProps = {
	content?: string;
	children?: React.ReactNode;
	level?: number; // 1-6
	className?: string;
};

export default function HeaderRenderer({
	content,
	children,
	level = 1,
	className = "",
}: THeaderRendererProps) {
	const Tag = `h${level}` as keyof JSX.IntrinsicElements;
	const headerClass = `markdown-h${level}`;

	const parts = content?.split(/(`[^`]+`)/) ?? [];

	return (
		<Tag className={`${headerClass} ${className}`}>
			{parts.map((part, i) =>
				part.startsWith("`") && part.endsWith("`") ? (
					<code key={i}>{part.slice(1, -1)}</code>
				) : (
					part
				)
			)}
			{children}
		</Tag>
	);
}
